import React, { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { ORG_LABELS, TEAM_LABELS } from '../config';
import { Badge, Segmented, Tabs } from '../ui/basics';
import Daily from './recruitment/Daily';
import Overview from './recruitment/Overview';
import Period from './recruitment/Period';
import EndedEarly from './recruitment/EndedEarly';
import ProjectedEnds from './recruitment/ProjectedEnds';
import Weekly from './recruitment/Weekly';

const TABS = [
  { key: 'overview', label: 'Active / Inactive', Component: Overview },
  { key: 'weekly', label: 'Weekly', Component: Weekly },
  { key: 'daily', label: 'Daily', Component: Daily },
  { key: 'period', label: 'Team Periods', Component: Period },
  { key: 'projected', label: 'Projected Ends', Component: ProjectedEnds },
  { key: 'early', label: 'Ended Early', Component: EndedEarly },
];

export default function Recruitment() {
  const { org, teams, allTeams } = useAuth();
  const [tab, setTab] = useState('overview');
  const [lead, setLead] = useState('');
  // Users limited to some teams can only pick among those; '' means "all of my teams".
  const options = [
    ...(allTeams || teams.length > 1 ? [{ value: '', label: allTeams ? 'All teams' : 'All my teams' }] : []),
    ...(allTeams ? Object.keys(TEAM_LABELS) : teams).map((t) => ({ value: t, label: TEAM_LABELS[t] })),
  ];
  const fixedLead = !allTeams && teams.length === 1 ? teams[0] : null;
  const effectiveLead = fixedLead || lead;
  useEffect(() => setLead(''), [org]);

  const { Component } = TABS.find((t) => t.key === tab);
  return (
    <div className="stack">
      <div className="page-head">
        <div><h1>Recruitment</h1><p>{ORG_LABELS[org]} · margin, candidates and team performance</p></div>
        <div className="actions">
          {fixedLead ? <Badge tone="accent">{TEAM_LABELS[fixedLead]} team</Badge>
            : options.length > 1 && <Segmented options={options} value={lead} onChange={setLead} />}
        </div>
      </div>
      <Tabs tabs={TABS} value={tab} onChange={setTab} />
      <Component key={`${org}-${effectiveLead}`} org={org} lead={effectiveLead} />
    </div>
  );
}
